'use client'
import React, {useContext, useState} from "react";
import Column from "@/components/ContentElements/Grid/Column";
import {NewsTeaserProps} from "@/libs/contentful/fetch/content/news";
import NewsTeaser from "@/components/ContentElements/News/NewsTeaser/NewsTeaser";
import {
    ContentContext,
    ContentTypeContext,
    YearContext
} from "@/components/ContentElements/News/Provider/NewsFilterProvider";
import Text from "@/components/typographie/Text/Text";
import IconRenderer from "@/libs/contentful/helper/IconRenderer";
import {AssetFields} from "contentful";
import {useTranslations} from "next-intl";
import {
    numberOfContentTagsContext,
    NumberOfContentTypesContext, NumberOfYearsContext
} from "@/components/ContentElements/News/Provider/NewsCounterProvider";

interface Props {
    newsList: NewsTeaserProps[]
    contentTags?: string[] | null
    filterActive?: boolean
    numberOfShownNewsTeaser: number
}

export default function NewsList({newsList, contentTags, filterActive = false, numberOfShownNewsTeaser}:Props) {
    const t = useTranslations();
    const [sortOrder, setSortOrder] = useState('asc')
    const [numberOfShownTeaser, setNumberOfShownTeaser] = useState(numberOfShownNewsTeaser)

    const { filterContent } = useContext(ContentContext)
    const { filterContentType } = useContext(ContentTypeContext)
    const { filterYear } = useContext(YearContext);

    const { numberOfContentTags } = useContext(numberOfContentTagsContext);
    const { numberOfContentTypes } = useContext(NumberOfContentTypesContext);
    const { numberOfYears } = useContext(NumberOfYearsContext);

    const resetCounter = (arr: { [key: string]: number }[]) => {
        arr.forEach(obj => {
            Object.keys(obj).forEach(key => {
                obj[key] = 0
            })
        })
    }

    resetCounter([numberOfContentTags, numberOfContentTypes, numberOfYears]);

    const newsCounter = (obj: { [key: string]: number }, arr:string[]) => {
        arr.forEach(item => obj.hasOwnProperty(item) ? obj[item] += 1 : null)
    }

    newsList.forEach(item => {
        if(!item.contentTags || !item.contentType || !item.date) return
        newsCounter(numberOfContentTags, item?.contentTags)
        newsCounter(numberOfContentTypes, [item.contentType])
        const year = new Date(item.date).getFullYear();
        newsCounter(numberOfYears, [String(year)])
    });

    if(!contentTags) newsList.sort((a, b) => new Date(b.date).valueOf() - new Date(a.date).valueOf())
    newsList = sortOrder === 'asc' ? newsList : [...newsList].reverse()

    let shownTeaser = newsList.slice(0, numberOfShownTeaser)
    let filteredNews = []

    if(filterActive) {
        filteredNews = newsList.filter(item => {
            if(!item.contentTags || !item.contentType || !item.date) return
            return (
                (filterContent === '' || item.contentTags.some(contentTags => contentTags === filterContent)) &&
                (filterContentType === '' || item.contentType === filterContentType) &&
                (filterYear === '' || String(new Date(item.date).getFullYear()) === filterYear)
            );
        });

        shownTeaser = filteredNews.slice(0, numberOfShownTeaser)
    }

    const changeOrder = () => {
        if (!document.startViewTransition) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
            return;
        }
        document.startViewTransition(() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc'));
    }

    const showMoreTeaser = () => {
        if (!document.startViewTransition) {
            setNumberOfShownTeaser(numberOfShownTeaser + 3)
            return;
        }
        document.startViewTransition(() => setNumberOfShownTeaser(numberOfShownTeaser + 3));
    }
    return (
        <>
            {filterActive && <div className="flex items-center justify-between w-full">
                <Text>{filteredNews.length} results</Text>
                <button type="button" onClick={() => changeOrder()}
                        className="text-p font-sans md:whitespace-pre-wrap font-bold flex items-center gap-xs">
                    <IconRenderer icon="icon-sort" className=""/>
                    {sortOrder === 'asc' ? t("News.newToOld") : t("News.oldToNew")}
                    <IconRenderer icon="icon-chevron-down" className=''/>
                </button>
            </div>}
            {newsList.length > 0 && shownTeaser.map((news) => (
                <Column key={news.id} width="1/3">
                    <NewsTeaser slug={news.slug}
                                media={news.image as AssetFields}
                                headline={news.headline}
                                contentTags={news.contentTags}
                                contentType={news.contentType}
                                contentTypeIcon={news.contentTypeIcon}
                                date={news.date}
                    />
                </Column>
            ))}
            {filterActive && filteredNews.length > numberOfShownTeaser  && <Column width="1" align="center">
                <button onClick={() => showMoreTeaser()} type="button" className="bg-black text-white text-above font-bonprix rounded border border-black px-2xl py-s brand-transition hover:bg-white hover:text-black focus-visible:outline-offset-[5px] focus-visible:outline-2 focus-visible:outline-outline focus-visible:bg-white focus-visible:text-black focus:hover:outline-none focus-visible:hover:outline-none outline-outline">
                    {t("Defaults.loadMore")}
                </button>
            </Column>}
        </>
    )
}